import { render, staticRenderFns } from "./IngresoArticulos.vue?vue&type=template&id=5cd8db19&scoped=true"
import script from "./IngresoArticulos.vue?vue&type=script&lang=js"
export * from "./IngresoArticulos.vue?vue&type=script&lang=js"
import style0 from "./IngresoArticulos.vue?vue&type=style&index=0&id=5cd8db19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd8db19",
  null
  
)

export default component.exports